import { INTERNSHIP_STATUS, ROUTE_PATH, TEMPLATE_OPTIONS } from "common/constants/sm-constants";
import { FormMetaModel, SmBtnMetaModel, SmDatepickerModel, SmMetaInputModel, SmMetaSelectModel } from "common/models/utility-models/meta-model";

export class InternshipMetaModel extends FormMetaModel {

    constructor() {
        super('Internship', ROUTE_PATH.internship, '', 2);
    }

    override initProperties(): any {

        const studentHeaders = [
            { key: 'name', label: 'Student Name' },
            { key: 'invite', label: 'Invite' },
            { key: 'reInvite', label: 'Internship Re-Invite' },
            { key: 'available', label: 'Available Y/N' },
            { key: 'assigned', label: 'Assigned' },
            { key: 'startDate', label: 'Student Expected Start Date' },
            { key: 'endDate', label: 'Student Expected End Date' },
            { key: 'company', label: 'External Company' },
            { key: 'companyLocation', label: 'External Company Location' },
            { key: 'certificate', label: 'Internship Certificate' },
            { key: 'email', label: 'E-Mail' },
            { key: 'mobile', label: 'Mobile' },
            { key: 'branch', label: 'Branch' },
            { key: 'college', label: 'College' },
            { key: 'region', label: 'Region' }
        ];


        const internshipHeaders = [
            { key: 'internshipTitle', label: 'Internship Title' },
            { key: 'companyName', label: 'Internship Company' },
            { key: 'location', label: 'Location' },
            { key: 'startDate', label: 'Start Date' },
            { key: 'endDate', label: 'End Date' },
            { key: 'mentorName', label: 'Mentor Name' },
            { key: 'studentCount', label: 'Student Count' }
        ];



        //const showInternshipSection: boolean = false;
        const studentIds: any[] = [];
        const tableHeaders: any[] = [];
        const selectedInternships: boolean[] = [];
        const year = '2024';
        const batches = ['2021', '2022', '2023', '2024'];
        const regions = ['North', 'South', 'East', 'West'];
        const states = ['Delhi', 'Mumbai', 'Kolkata', 'Chennai'];
        const branches = ['CSE', 'IT', 'ECE', 'ME'];
        const selectedOption = 'student';
        const selectedBatch = [];
        const selectedRegion = [];
        const selectedState = [];
        const selectedBranch = [];
        const inviteStatus = 'not_invited';
        const searchText = "";
       // const fromDate = '';
        const fromDate = new SmDatepickerModel(
            'fromDate',
            'fromDate',
            'datepicker',
            true,
            'col-12 col-md-4',
            1,
            1,
            '',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            '01/01/1970',
            [],
            false
          );
        const toDate = new SmDatepickerModel(
            'toDate',
            'toDate',
            'datepicker',
            true,
            'col-12 col-md-4',
            1,
            3,
            '',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'DD/MM/YYYY',
            new Date('1970-10-19'),
            new Date('2040-01-01'),
            [],
            false
          );
        const add = new SmBtnMetaModel('Add Internship', '', true, false, true, true, false);
        const filteredStudents = [];
        const filteredInternships = [];
        const filteredData = [...filteredStudents];
        const showInternshipSection: boolean = false;
        const internshipStats = [];

        return {
            studentHeaders,
            internshipHeaders,
            batches,
            regions,
            states,
            branches,
            selectedBatch,
            selectedRegion,
            selectedState,
            selectedBranch,
            inviteStatus,
            searchText,
            fromDate,
            toDate,
            add,
            filteredData,
            filteredInternships,
            filteredStudents,
            selectedOption,
            showInternshipSection,
            selectedInternships,
            internshipStats
        };
    }
}